import { useRouter } from 'next/router';
import { baseBaseUrl } from '@constants';
import { categoryBasePath, interviewBasePath, casestudyListPath } from '@paths';

const fixPath = (s: string) =>
  s
    .replace(
      new RegExp(`^${categoryBasePath}/interview/`),
      `${interviewBasePath}/`
    )
    .replace(
      new RegExp(`^${categoryBasePath}/casestudy/`),
      `${casestudyListPath()}/`
    )
    .replace(
      new RegExp(`^${categoryBasePath}/corporation-casestudy/`),
      `${casestudyListPath('corporation-casestudy')}/`
    );

export const useCanonical = () =>
  `${baseBaseUrl}${fixPath(useRouter().asPath.replace(/\?.*$/, ''))}`;
